import { useLayoutEffect } from 'react';
export var MINDSET_HIDE_FLOATING_EVENT = 'mindset:hide-floating';
export var MINDSET_SHOW_FLOATING_EVENT = 'mindset:show-floating';
var hideRequestCount = 0;
export function isMindsetFloatingPanelHidden() {
  return hideRequestCount > 0;
}

/**
 * useHideMindsetFloatingPanel
 * Hides the floating Mindset panel while the calling component is mounted —
 * for pages/components that embed their own Mindset agent instead (e.g. MindsetCard),
 * to avoid two simultaneous agent instances. Uses useLayoutEffect rather than
 * useEffect so the hide signal lands before the floating panel's first paint.
 */
export function useHideMindsetFloatingPanel() {
  useLayoutEffect(function () {
    if (typeof window === 'undefined') return;
    hideRequestCount += 1;
    if (hideRequestCount === 1) {
      window.dispatchEvent(new CustomEvent(MINDSET_HIDE_FLOATING_EVENT));
    }
    return function () {
      hideRequestCount = Math.max(0, hideRequestCount - 1);
      if (hideRequestCount === 0) {
        window.dispatchEvent(new CustomEvent(MINDSET_SHOW_FLOATING_EVENT));
      }
    };
  }, []);
}